import { Pipe, PipeTransform } from '@angular/core';
import { LabelIdentifiers, PlcCodes } from '@dch/products-business-logic';

@Pipe({
  name: 'removeDuplicateProducts',
})
export class RemoveDuplicateProductsPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      const duplicatesCLD = value.filter((p) => p.plc === PlcCodes.CLD);
      const duplicatesTVE = value.filter((p) => p.plc === PlcCodes.TVE);
      const duplicatesFON = value.filter(
        (p) => p.labelIdentifier === LabelIdentifiers.FON,
      );
      let result = value;
      if (duplicatesCLD.length > 1) {
        result = result.filter((p) => p.plc !== PlcCodes.CLD);
        result = result.concat(duplicatesCLD[0]);
      }
      if (duplicatesTVE.length > 1) {
        result = result.filter((p) => p.plc !== PlcCodes.TVE);
        result = result.concat(duplicatesTVE[0]);
      }
      if (duplicatesFON.length > 1) {
        result = result.filter(
          (p) => p.labelIdentifier !== LabelIdentifiers.FON,
        );
        result = result.concat(duplicatesFON[0]);
      }
      return result;
    }
    return value;
  }
}
